import React, { Component } from 'react';
import { connect } from 'react-redux';
import {List, Map} from "immutable";
import {Icon} from "@blueprintjs/core";
import moment from "moment";
import {isFloat} from 'validator';

// Componentes
import Select from "../../components/common/virtualized-select";
import VirtualizedTable from "../common/virtualized-table";
import DateInput from "../common/date-input";
import {projectTasks} from "../../components/common/project-tasks"

// Actions
import {getEmployees, cleanEmployees} from "../../actions/employees";

class ProjectWorkReportsDialog extends Component {
    constructor(props) {
        super(props);

        this.state = {
            canPushWorkReport: false,
            employee: -1,
            date: moment(),
            hours: '',
            task: -1,
            cost_per_hour: 0,
            workReports: List([])
        }
    }

    componentDidMount() {
        this.props.onRef(this);
        this.props.getEmployees({
            filters: { status: 'active' },
            projection: 'employee_code name cost_per_hour'
        });
    }
    componentWillUnmount() {
        this.props.onRef(undefined);
        this.props.cleanEmployees();
    }

    onSaveButtonClick = () => {
        this.props.createWorkReports(this.state.workReports, {
            projection: 'date employee task hours cost',
            populateRefs: true
        });
        this.props.onCloseModal();
    };

    validateSubmit = () => {
        this.props.onCanSubmit(this.state.workReports.size > 0);
    };

    validateWorkRecord = () => {
        this.setState({
            canPushWorkReport: this.state.employee !== -1 && this.state.date.isValid() && this.state.task !== -1 && this.state.hours > 0
        })
    };

    render() {

        // New Work Records Table
        let tableSettings = {
            sortable: false,
            filterable: false,
            defaultSortFields: [],
            defaultSortDirections: ['asc'],
            height: 160,
            rowHeight: 40,
            strippedRows: false
        };
        let tableData = this.state.workReports;
        let tableColumns = {
            date: {
                title: "Fecha",
                columnType: 'function',
                dataField: 'date',
                width: 100,
                style: {},
                sortable: false,
                filterable: true,
                nodeContent: (date) => {
                    return moment(date).format('DD/MM/YYYY') ;
                }
            },
            employee: {
                title: "Empleado",
                columnType: 'function',
                dataField: 'employee',
                width: 100,
                style: {},
                sortable: false,
                filterable: false,
                nodeContent: (employeeId) => {
                    return this.props.employees.find(employee => employee.get('_id') === employeeId).get('name');
                }
            },
            task: {
                title: "Tarea",
                columnType: 'function',
                dataField: 'task',
                width: 100,
                style: {},
                sortable: false,
                filterable: false,
                nodeContent: (task_code) => {
                    return projectTasks.find(task => task.get('task_code') === task_code).get('name');
                }
            },
            hours: {
                title: "Horas",
                columnType: 'text',
                dataField: 'hours',
                width: 100,
                style: {textAlign: 'right'},
                sortable: false,
                filterable: false
            },
            actions: {
                title: '',
                columnType: 'function',
                dataField: '_id',
                width: 100,
                style: { alignItems: 'center', maxWidth: 30 },
                sortable: false,
                filterable: false,
                nodeContent: (workRecordId) => {
                    return (
                        <Icon className="cursor-pointer" icon="trash" title="Eliminar" onClick={() => {
                            let updatedNewWorkRecords = List([]);

                            this.state.workReports.delete(workRecordId).map((workRecord, index) => {
                                return updatedNewWorkRecords = updatedNewWorkRecords.push(workRecord.merge({ _id: index }));
                            });
                            this.setState({ workReports: updatedNewWorkRecords }, this.validateSubmit)
                        }} />
                    );
                }
            }
        };

        return (
            <div>
                <div className="row modal-row">
                    <div className="col-4">
                        <label style={{ color: 'black', fontSize: 14, fontWeight: 600 }}>Proyecto</label>
                        <input
                            className="form-control"
                            type="text"
                            value={`[${this.props.project.get('project_code')}] ${this.props.project.get('name')}`}
                            disabled={true}
                        />
                    </div>
                    <div className="col-4">
                        <div className="form-group">
                            <label style={{ color: 'black', fontSize: 14, fontWeight: 600 }}>Fecha</label>
                            <DateInput
                                onChange={(selectedValue) => this.setState({
                                    date: selectedValue
                                }, this.validateWorkRecord)}
                                value={this.state.date}
                                inputWrapperStyle={{height: 40}}
                                inputStyle={{height: 37, borderRadius: 0, border: '1px solid #ccc'}}
                                iconStyle={{top: 9, right: 12}}
                            />
                        </div>
                    </div>
                </div>
                <div className="row modal-row">
                    <div className="col-4">
                        <label style={{ color: 'black', fontSize: 14, fontWeight: 600 }}>Empleado</label>
                        <Select
                            className="virtualized-select"
                            options={this.props.employees.toJS()}
                            value={this.state.employee}
                            labelKey="select"
                            valueKey="_id"
                            matchProp="select"
                            multi={false}
                            searchable={true}
                            clearable={false}
                            onChange={(employee) => {
                                if (employee) {
                                    this.setState({
                                        employee: employee._id,
                                        cost_per_hour: employee.cost_per_hour
                                    }, this.validateWorkRecord);
                                }
                            }}
                        />
                    </div>
                    <div className="col-4">
                        <label style={{ color: 'black', fontSize: 14, fontWeight: 600 }}>Tarea</label>
                        <Select
                            className="virtualized-select"
                            options={projectTasks.toJS()}
                            value={this.state.task}
                            labelKey="name"
                            valueKey="task_code"
                            matchProp="name"
                            multi={false}
                            searchable={true}
                            clearable={false}
                            onChange={(task) => {
                                if (task) {
                                    this.setState({ task: task.task_code }, this.validateWorkRecord);
                                }
                            }}
                        />
                    </div>
                </div>
                <div className="row modal-row" style={{ paddingTop: 10 }}>
                    <div className="col-4">
                        <label style={{ color: 'black', fontSize: 14, fontWeight: 600 }}>Coste por hora</label>
                        <input
                            className="form-control"
                            type="text"
                            value={this.state.cost_per_hour}
                            onChange={ (event) => {
                                let cost_per_hour = event.target.value;
                                if (cost_per_hour === '') cost_per_hour = '0';
                                if (isFloat(cost_per_hour)) {
                                    this.setState({ cost_per_hour }, this.validateWorkRecord);
                                }
                            }}
                        />
                    </div>
                    <div className="col-4">
                        <label style={{ color: 'black', fontSize: 14, fontWeight: 600 }}>Horas</label>
                        <input
                            className="form-control"
                            type="text"
                            value={this.state.hours}
                            onChange={ (event) => {
                                let hours = event.target.value;
                                if (hours === '') hours = '0';
                                if (isFloat(hours)) {
                                    this.setState({ hours }, this.validateWorkRecord);
                                }
                            }}
                        />
                    </div>
                    <div className="col-auto mr-auto" style={{ paddingTop: 27 }} >
                        <button
                            className="btn btn-custom"
                            onClick={ () => {
                                const workRecord = Map({
                                    _id: this.state.workReports.size,
                                    employee: this.state.employee,
                                    project: this.props.project.get('_id'),
                                    date: this.state.date,
                                    hours: this.state.hours,
                                    task: this.state.task,
                                    cost: this.state.cost_per_hour * this.state.hours,
                                });

                                this.setState({
                                    employee: -1,
                                    date: moment(),
                                    hours: '',
                                    task: -1,
                                    cost_per_hour: 0,
                                    workReports: this.state.workReports.push(workRecord)
                                }, () => {
                                    this.validateWorkRecord();
                                    this.validateSubmit();
                                })
                            }}
                            disabled={!this.state.canPushWorkReport}
                        >Añadir</button>
                    </div>
                </div>
                <div className="row modal-row" style={{ paddingTop: 10 }}>
                    <div className="col">
                        <VirtualizedTable
                            tableSettings={tableSettings}
                            tableColumns={tableColumns}
                            tableData={tableData}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    // Reducers
    const employeesReducer = state.employees;
    const stockReducer = state.stock;


    // Employees
    let employees = employeesReducer.get('payload') || List([]);
    if (!(employees instanceof List)) employees = List([]);
    if (employees.size > 0) {
        employees = employees.map(employee => employee.set('select', `[${employee.get('employee_code')}] ${employee.get('name')}`));
    }
    employees = employees.insert(0, Map({ _id: -1, select: 'Selecciona un empleado' }));

    // Stock
    const stockList = stockReducer.get('payload') || List([]);
    let productList = List([]);

    stockList.map(stock => {
        return productList = productList.insert(productList.size, stock.get('product'));
    });

    return {
        employees,
        productList
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getEmployees: (query) => dispatch(getEmployees(query)),
        cleanEmployees: () => dispatch(cleanEmployees())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProjectWorkReportsDialog);


// WEBPACK FOOTER //
// ./src/components/dialogs/ProjectWorkReportsDialog.js